export enum MajorBreakpoint {
    Mobile,
    Desktop,
}

/**
 * Returns the current major breakpoint
 */
export function getCurrentMajorBreakpoint(): MajorBreakpoint {
    const currentBreakpoint = o_global.breakpoint.getCurrentBreakpoint();
    return currentBreakpoint === 's' || currentBreakpoint === 'm' ? MajorBreakpoint.Mobile : MajorBreakpoint.Desktop;
}
